(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5978],{

/***/ 39342:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-and-conditions",
      function () {
        return __webpack_require__(99902);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41749);
/* harmony import */ var _resources_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15287);
/* harmony import */ var _utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43948);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);






var TermsAndConditions = function() {
    var t = (0,_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)([
        "terms-and-conditions"
    ]).t;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_general__WEBPACK_IMPORTED_MODULE_1__/* .Page */ .T3, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_1__/* .PageBanner */ .ef, {
                title: t("title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_1__/* .GridLayout */ .Me, {
                section: true,
                justify: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    item: true,
                    xs: 10,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_general__WEBPACK_IMPORTED_MODULE_1__/* .StyledParagraph */ .MU, {
                        color: _resources_styles__WEBPACK_IMPORTED_MODULE_2__/* .color.black */ .$.black,
                        component: "div",
                        dangerouslySetInnerHTML: {
                            __html: t("content")
                        }
                    })
                })
            })
        ]
    }));
};
TermsAndConditions.ageVerification = false;
/* harmony default export */ __webpack_exports__["default"] = (TermsAndConditions);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(39342); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);